"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function RightThin(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "3.661 3.752 3.661 11.252 11.161 11.252 11.161 12.252 2.661 12.252 2.661 3.752", transform: "rotate(-135 6.411 8.21)" })));
}
exports.default = RightThin;
//# sourceMappingURL=RightThin.js.map